var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHistoryWhite = function SvgIconHistoryWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.1 0A10.927 10.927 0 0 0 2.566 8.223l-.732-1.107a1 1 0 1 0-1.668 1.1l2.2 3.334c.153.214.378.365.634.425.261.052.532 0 .756-.145l3.3-2.223A1 1 0 1 0 5.94 7.948L4.44 8.96A8.909 8.909 0 1 1 13.1 20a8.893 8.893 0 0 1-7.281-3.822 1 1 0 1 0-1.64 1.143A10.88 10.88 0 0 0 23.999 11 10.963 10.963 0 0 0 13.1 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 4.95a1 1 0 0 0-1 1V11c.004.264.109.517.293.707l3 3.027a1.013 1.013 0 0 0 1.414.007 1 1 0 0 0 .006-1.414L14 10.59V5.95a1 1 0 0 0-1-1Z"
  })));
};
export default SvgIconHistoryWhite;